 
 <app-doc-payants  *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
 [disabled]="disabled"
  [docPayants]="infosSup?.docPayants"></app-doc-payants>
 
 <app-form-input *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="infosSup?.dateLimiteObtention" 
 
[label]="step11.getdatelimiteobtention"
[type]="'date'" [rule]="''"
[name]="getUid()+'_SepAtt_dateLimiteObtention'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="infosSup?.conditionsModePaiement" 
 
[label]="step11.getconditionsmodepaiement"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_conditionsModePaiement'">
</app-form-input>
